import { render, staticRenderFns } from "./suspension.vue?vue&type=template&id=1bcb6d3a&scoped=true"
import script from "./suspension.vue?vue&type=script&lang=js"
export * from "./suspension.vue?vue&type=script&lang=js"
import style0 from "./suspension.vue?vue&type=style&index=0&id=1bcb6d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb6d3a",
  null
  
)

export default component.exports